module.exports = __webpack_public_path__ + "static/img/14.6f2e8a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/eng/14.png
// module id = T4+0
// module chunks = 0